import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
})
export class TimeAgoPipe implements PipeTransform {
  private readonly MILLISECONDS_IN_HOUR = 1000 * 60 * 60;
  private readonly HOURS_IN_DAY = 24;

  transform(createdAt: string): string {
    const timeDiff = Date.now() - new Date(createdAt).getTime();
    const hours = Math.floor(timeDiff / this.MILLISECONDS_IN_HOUR);
    if (hours < this.HOURS_IN_DAY) {
      return `${hours} hrs`;
    }
    const days = Math.floor(hours / this.HOURS_IN_DAY);
    return `${days} days`;
  }
}
